import { InitiateDebitMandateResponse, InitiateDebitMandate } from "../model/payments/payments";
import { apiSlice } from "../stores/base/api-slice";
const directDebitEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		initiateDebitMandate: builder.mutation<InitiateDebitMandateResponse, InitiateDebitMandate>({
			query: body => ({
				url: `/direct-debit/initiate-direct-debit-mandate`,
				method: "POST",
				body,
			}),
		}),
		chargeMonthlyRepayment: builder.mutation<any, string>({
			query: orderId => ({
				url: `/direct-debit/charge/${orderId}`,
				method: "POST",
			}),
		}),
		chargeRemainder: builder.mutation<any, string>({
			query: orderId => ({
				url: `/direct-debit/charge/remainder/${orderId}`,
				method: "POST",
			}),
		}),
		chargeAnyAmount: builder.mutation<string, any>({
			query: request => ({
				url: `/direct-debit/charge/arbitrary`,
				method: "POST",
				body: request,
			}),
		}),
		checkAccountBalance: builder.mutation<{ hasSufficientBalance: boolean; accountBalance: number }, any>({
			query: request => ({
				url: `/direct-debit/account-balance-inquiry`,
				method: "POST",
				body: request,
			}),
		}),
	}),
});
export const {
	useInitiateDebitMandateMutation,
	useChargeRemainderMutation,
	useChargeMonthlyRepaymentMutation,
	useChargeAnyAmountMutation,
	useCheckAccountBalanceMutation,
} = directDebitEndpoints;
